import React, {Component} from 'react';
import {
  Row,
  Col,
  Form,
  InputGroup,
  InputGroupAddon,
  Input,
} from 'reactstrap';
import {Field, Form as FinalForm} from 'react-final-form';
import {NotificationManager} from '../components/common/react-notifications';
import LoaderButton from '../components/LoaderButton';
import {difference} from '../helpers/Utils';
import {forEach, isEmpty} from 'lodash';
import ModalManager from '../components/modal/ModalManager';
import FieldError from '../components/FieldError';
import {withTranslation} from 'react-i18next';
import Rbac from '../components/Rbac';
import Api from '../services/Api';

class KycDetailsMetaInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      info: {...props.kycInfo},
    };
  }

  updateInfo = async values => {
    try {
      const {t, userId} = this.props;
      const formData = new FormData();
      formData.append('userId', userId);
      const diff = difference(values, this.state.info);
      if (!isEmpty(diff)) {
        forEach(diff, (value, key) => {
          formData.append(key, value);
        });
        const response = await Api.invoke('PATCH', '/admin-ui/user-kyc-info', formData);
        this.setState({
          info: {
            ...this.state.info,
            ...response.data,
          },
        });
        NotificationManager.success(t('Stats updated successfully'), t('Message'));
      } else {
        NotificationManager.warning(t('Stats has not be changed'), t('Message'));
      }
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  updateNationalCode = async values => {
    try {
      const {info} = this.state;
      const {t, userId} = this.props;
      const {data} = await Api.invoke('PATCH', '/admin-ui/user-kyc-items', {
        userId,
        id: info.id,
        value: values.nationalCode,
      });
      this.setState({
        info: {
          ...info,
          ...values,
          shahkarVerified: data.shahkarVerified,
        },
      });
      NotificationManager.success(t('User national code updated successfully'), t('Message'));
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  updatePhoneNumber = async values => {
    try {
      const {info} = this.state;
      const {t, userId} = this.props;
      const {data} = await Api.invoke('PUT', '/admin-ui/user-phone-number', {
        ...values,
        userId,
      });
      this.setState({
        info: {
          ...info,
          ...values,
          shahkarVerified: data.shahkarVerified,
        },
      });
      NotificationManager.success(t('User mobile number updated successfully'), t('Message'));
      // if (info.shahkarVerified) {
      //   this.showPhoneNumberChangedModal();
      // }
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  onChangePhoneNumberStatus = async confirmed => {
    const {info} = this.state;
    const {t, userId} = this.props;
    this.setState({
      info: {
        ...info,
        phoneNumberVerified: confirmed,
      },
    });
    try {
      const {data} = await Api.invoke('PATCH', '/admin-ui/user-kyc-info', {
        userId,
        phoneNumberVerified: confirmed,
      });
      this.setState({
        info: {
          ...info,
          phoneNumberVerified: confirmed,
          ...(typeof data.shahkarVerified === 'boolean' ? {
            shahkarVerified: data.shahkarVerified,
          } : null)
        },
      });
      NotificationManager.success(t('Mobile number status updated successfully'), t('Message'));
    } catch (e) {
      this.setState({
        info: {
          ...info,
          phoneNumberVerified: !confirmed,
        },
      });
    }
  };

  showNationalCodeChangedModal = () => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Notice'),
      body: t('Due to the change of user national code, you have to re-inquire about matching the national code and mobile number.'),
      buttons: [
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('I realized'),
        },
      ],
    });
  }

  showPhoneNumberChangedModal = () => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Notice'),
      body: t('Due to the change of user mobile number, you have to re-inquire about matching the national code and mobile number.'),
      buttons: [
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('I realized'),
        },
      ],
    });
  };

  inquirySSN = async () => {
    try {
      const {t} = this.props;
      const {data} = await Api.invoke('GET', `/v2/admin-ui/inquiries/kycDocuments/${this.state.info.id}`);
      this.setState({
        info: {
          ...this.state.info,
          ssnVerified: data.status === "VERIFIED" ? true : this.state.info.ssnVerified,
        }
      });
      if (data.message) {
        if (data.status === "VERIFIED") {
          NotificationManager.success(data.message, t('Message'), 10000);
        } else {
          NotificationManager.error(data.message, t('Message'), 10000);
        }
      }
    } catch(e) {
      console.log('error: ', e);
    }
  };

  inquiryBirthDate = async () => {
    try {
      const {t} = this.props;
      const {data} = await Api.invoke('GET', `/v2/admin-ui/inquiries/kycDocuments/${this.state.info.id}`);
      this.setState({
        info: {
          ...this.state.info,
          birthDateVerified: data.status === "VERIFIED" ? true : this.state.info.birthDateVerified,
        }
      });
      if (data.message) {
        if (data.status === "VERIFIED") {
          NotificationManager.success(data.message, t('Message'), 10000);
        } else {
          NotificationManager.error(data.message, t('Message'), 10000);
        }
      }
    } catch(e) {
      console.log('error: ', e);
    }
  };

  render() {
    const {t} = this.props;
    const {info} = this.state;
    return (
      <Row>
        <Col className="col-6">
          {info.name === "SSN" &&
            <div className="mb-3">
              <FinalForm
                onSubmit={this.updateNationalCode}
                initialValues={{nationalCode: info.value ? info.value : undefined}}
                render={({handleSubmit, submitting, pristine}) => {
                  return (
                    <Form onSubmit={handleSubmit}>
                      <div>
                        <div>
                          <span>{t('National Code')}</span>
                        </div>
                        <Field name="nationalCode">
                          {({input}) => (
                            <InputGroup>
                              <Input
                                {...input}
                                placeholder={
                                  Rbac.hasPermission('update_user-kyc') ?
                                    t('Enter user national code') : ''
                                }
                              />
                              <Rbac permission='update_user-kyc'>
                                <InputGroupAddon addonType="append">
                                  <LoaderButton
                                    loading={submitting}
                                    onClick={handleSubmit}
                                    disabled={pristine || submitting}
                                    className='d-flex align-items-center justify-content-center'
                                    style={{height: 35}}
                                  >
                                    {t('Save')}
                                  </LoaderButton>
                                </InputGroupAddon>
                              </Rbac>
                              <FieldError name="nationalCode"/>
                            </InputGroup>
                          )}
                        </Field>
                      </div>
                    </Form>
                  );
                }}
              />
            </div>
          }
          {info.name === "SSN" &&
            <Rbac permission='update_user-kyc'>
              <div className="mb-3">
                <FinalForm
                  onSubmit={this.inquirySSN}
                  render={({handleSubmit, submitting}) => {
                    return (
                      <div>
                        <div className="mb-2">
                          <span>
                           {t('SSN Inquiry')}
                            <span className={info.ssnVerified ? 'text-success' : 'text-danger'}>
                             {info.ssnVerified ? ` (${t('confirmed')})` : ` (${t('not confirmed')})`}
                            </span>
                          </span>
                        </div>
                        <LoaderButton
                          color="success"
                          loading={submitting}
                          onClick={handleSubmit}
                          style={{minWidth: 120}}
                          className="d-flex justify-content-center"
                          disabled={
                            submitting ||
                            !info.nationalCode ||
                            !info.phoneNumber ||
                            !info.phoneNumberVerified
                          }
                        >
                          {t('Inquiry')}
                        </LoaderButton>
                      </div>
                    );
                  }}
                />
              </div>
            </Rbac>
          }
          {info.name === "BIRTH_DATE" &&
            <Rbac permission='update_user-kyc'>
              <div className="mb-3">
                <FinalForm
                  onSubmit={this.inquiryBirthDate}
                  render={({handleSubmit, submitting}) => {
                    return (
                      <div>
                        <div className="mb-2">
                          <span>
                           {t('Birth Date Inquiry')}
                            <span className={info.birthDateVerified ? 'text-success' : 'text-danger'}>
                             {info.birthDateVerified ? ` (${t('confirmed')})` : ` (${t('not confirmed')})`}
                            </span>
                          </span>
                        </div>
                        <LoaderButton
                          color="success"
                          loading={submitting}
                          onClick={handleSubmit}
                          style={{minWidth: 120}}
                          className="d-flex justify-content-center">
                          {t('Inquiry')}
                        </LoaderButton>
                      </div>
                    );
                  }}
                />
              </div>
            </Rbac>
          }
        </Col>
      </Row>
    );
  }
}

export default withTranslation()(KycDetailsMetaInfo);
